module.exports = __webpack_public_path__ + "img/110.4ef7553d.png";